'use client';

import React, { useEffect, useRef } from 'react';
import Player from '@vimeo/player';

interface ILoopedVimeoPlayerProps {
    videoId: number;
    time?: number;
}

const LoopedVimeoPlayer = ({ videoId, time = 0.4 }: ILoopedVimeoPlayerProps) => {
    const vimeoRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const vimeoPlayer = new Player(vimeoRef.current ?? "", {
            id: videoId,
            muted: true,
            background: true,
            loop: true,
            autoplay: true,
            responsive: true,
        });

        const startTime = time;
        vimeoPlayer.setCurrentTime(startTime);

        vimeoPlayer.play();
    }, [time, videoId]);

    return <div className='relative w-full h-full overflow-hidden'>
        <div
            className='sm:max-md:-translate-y-24'
            ref={vimeoRef}
        />
    </div>
}

export default LoopedVimeoPlayer;
